import React from 'react';
import { Button, Modal } from 'react-bootstrap';

const IdleTimeOutModal = ({ showModal, handleClose, handleLogout, remainingTime, elapsedTime }) => {
   return (
      <Modal show={showModal} onHide={handleClose}>
         <Modal.Header closeButton>
            <Modal.Title>You Have Been Idle!</Modal.Title>
         </Modal.Header>
         <Modal.Body>{`You have been idle for ${elapsedTime} min`}</Modal.Body>
         <Modal.Footer>
            <Button className='btn btn-sm btn-custom text-white mb-4' onClick={handleLogout}>
               Close
            </Button>
         </Modal.Footer>
      </Modal>
   );
};

export default IdleTimeOutModal;
